import { FETCH_GET } from "../../config";

export const GET_ACTIVE_BLOGS_PENDING = "GET_ACTIVE_BLOGS_PENDING";
export const GET_ACTIVE_BLOGS_FULFILLED = "GET_ACTIVE_BLOGS_FULFILLED";
export const GET_ACTIVE_BLOGS_REJECTED = "GET_ACTIVE_BLOGS_REJECTED";

export const GET_BLOG_BY_SLUG_PENDING = "GET_BLOG_BY_SLUG_PENDING";
export const GET_BLOG_BY_SLUG_FULFILLED = "GET_BLOG_BY_SLUG_FULFILLED";
export const GET_BLOG_BY_SLUG_REJECTED = "GET_BLOG_BY_SLUG_REJECTED";

export const GET_RECENT_BLOGS_PENDING = "GET_RECENT_BLOGS_PENDING";
export const GET_RECENT_BLOGS_FULFILLED = "GET_RECENT_BLOGS_FULFILLED";
export const GET_RECENT_BLOGS_REJECTED = "GET_RECENT_BLOGS_REJECTED";

export const getActiveBlogs = () => {
  const query = `query={getActiveBlogs{id,title,slug,summary,image,tags,viewCount,created_at}}`;
  return async dispatch => {
    dispatch({ type: GET_ACTIVE_BLOGS_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({ type: GET_ACTIVE_BLOGS_REJECTED, payload: result.data.errors });
      } else {
        dispatch({ type: GET_ACTIVE_BLOGS_FULFILLED, payload: result.data.data.getActiveBlogs });
      }
    } catch (e) {
      dispatch({ type: GET_ACTIVE_BLOGS_REJECTED });
    }
  };
};

export const getBlogBySlug = (slug) => {
  const query = `query={getBlogBySlug(slug:"${slug}"){id,title,slug,content,summary,image,meta_title,meta_description,meta_keywords,tags,viewCount,created_at,recommendedProducts{id,name,slug,image,price,sale_price,stock}}}`;
  return async dispatch => {
    dispatch({ type: GET_BLOG_BY_SLUG_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({ type: GET_BLOG_BY_SLUG_REJECTED, payload: result.data.errors });
      } else {
        dispatch({ type: GET_BLOG_BY_SLUG_FULFILLED, payload: result.data.data.getBlogBySlug });
      }
    } catch (e) {
      dispatch({ type: GET_BLOG_BY_SLUG_REJECTED });
    }
  };
};

export const getRecentBlogs = (limit) => {
  var limitParam = limit || 6;
  var query = `query={getRecentBlogs(limit:${limitParam}){id,title,slug,summary,image,created_at}}`;
  return async dispatch => {
    dispatch({ type: GET_RECENT_BLOGS_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({ type: GET_RECENT_BLOGS_REJECTED, payload: result.data.errors });
      } else {
        dispatch({ type: GET_RECENT_BLOGS_FULFILLED, payload: result.data.data.getRecentBlogs });
      }
    } catch (e) {
      dispatch({ type: GET_RECENT_BLOGS_REJECTED });
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/blog.js